module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABA0lEQVRIibVVURKFIAhc3sX0ZuHN6GT7PiwqtXqWjxnHsQmWXVCAfxvJrqWq7Pn/05NMSokxRogIhzNYMidJmhmz672fkHUyKaXq4zRNh/M8z4gxgqR0MdhnSpLlOSf+O5NmcDMjidPgLRBV9XUL8EvwNhMsvhurZhelpAfNRQCyvQNACAFm5ufskztNSHpRY4yX9bqyEIIXXhVQRW6AUoqnthTb5VqL/wFyywHycj/K5ZYZwDvn6a6qzuLAZOue9yClTGuzQVVfBzczvwf7GgxlsF26AmC0TKcAo2SqJPqHTBXAaJlOAUbKRBYDJ79J+vg92tv6FlUTrWveXhjvJt0o+wK8D4fV+xvgmgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/DOCS.png
// module id = 54
// module chunks = 0